var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3 p-5 rounded text-center",staticStyle:{"background":"#f1f1f1"}},[_vm._v(" Debe estar registrado para acceder a esta sección ")])}
var staticRenderFns = []

export { render, staticRenderFns }